const initialState = {
    isLoading: false,
    isVerified: false,
    resendStatus: null, // "success" or "error"
    rememberDeviceStatus: null,
    errorMessage: "",
  };
  
  const EmailDialogReducer = (state = initialState, action) => {
    switch (action.type) {
      case "EMAIL_VERIFY_CODE_LOADING":
      case "RESEND_EMAIL_CODE_LOADING":
      case "REMEMBER_DEVICE_LOADING":
        return {
          ...state,
          isLoading: true,
          errorMessage: "",
        };
  
      case "EMAIL_VERIFY_CODE_SUCCESS":
        return {
          ...state,
          isLoading: false,
          isVerified: true,
          errorMessage: "",
          resendStatus: null,
        };
  
      case "EMAIL_VERIFY_CODE_ERROR":
        return {
          ...state,
          isLoading: false,
          isVerified: false,
          errorMessage: action.payload,
          resendStatus: null,
        };
  
      case "RESEND_EMAIL_CODE_SUCCESS":
        return {
          ...state,
          isLoading: false,
          resendStatus: "success",
          errorMessage: "",
          isVerified: false,
        };
  
      case "RESEND_EMAIL_CODE_ERROR":
        return {
          ...state,
          isLoading: false,
          resendStatus: "error",
          errorMessage: action.payload,
          isVerified: false,
        };
  
      case "REMEMBER_DEVICE_SUCCESS":
        return {
          ...state,
          isLoading: false,
          rememberDeviceStatus: "success",
          errorMessage: "",
          resendStatus: null
        };
  
      case "REMEMBER_DEVICE_ERROR":
        return {
          ...state,
          isLoading: false,
          rememberDeviceStatus: "error",
          errorMessage: action.payload,
          resendStatus: null
        };
  
      case "RESET_EMAIL_DIALOG_STATE":
        return { ...initialState };
  
      default:
        return state;
    }
  };
  
  export default EmailDialogReducer;
  